/*
  Cosmicis theme — app.js
  Cart drawer (Ajax /cart/add.js, /cart/change.js, /cart.js), mobile menu, quantity steppers,
  gallery thumbs, toast, and the product variant picker.

  Globals exposed:
    window.czCart          { open(), close(), refresh(), add(body), change(key, qty), render(cart), formatMoney(cents) }
    window.czToast(msg)
    window.czVariantPicker { init(rootEl) -> picker, get(el) -> picker|null }

  Variant picker contract (rootEl = the product section root, e.g. <div data-cz-product>):
    - one <script type="application/json" data-cz-variants> holding EITHER an array of variants
      ({{ product.variants | json }}) OR an object { options:[names], variants:[{id, options, price,
      price_formatted, available}], price_min_formatted } (what sections/main-product.liquid writes).
      Option names may also come from a separate <script data-cz-options>{{ product.options | json }}.
    - option buttons: <button type="button" class="cz-opt" data-value="US 6½ (16.9 mm)" aria-pressed="false">
      inside a group that names the option: data-option="Size" / data-position="2" on the button or on
      an ancestor (.cz-optbox[data-cz-option], [role=group][aria-label]). Labels wrapping radios also work.
      A button whose data-value is only the leading label ("US 6½") is matched by prefix to the full value.
    - <input type="hidden" name="id"> inside <form action="{{ routes.cart_add_url }}">; submit button [data-cz-add]
    - price element: [data-cz-price] or .cz-price (existing <small class="cz-from"> text is reused as the "From" label)
    - message element: [data-cz-optmsg] or .cz-optmsg
    - optional: a [data-cz-chosen] span inside each .cz-optbox row, filled with ": <b class=cz-chosen>value</b>"
    - optional root strings: data-msg-choose="Choose a %s first." data-msg-sold-out data-msg-add data-size-prefix="Size %s"
    Size buttons get their text rewritten to "US 6½" + <small>16.9 mm</small> if they
    do not already contain a <small>.
    Sections that bind their own qty/thumb handlers mark the root with data-cz-bound; app.js then
    leaves those controls alone.
*/
(function () {
  'use strict';

  var doc = document;
  function $(sel, root) { return (root || doc).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var DEFAULT_STRINGS = {
    empty: 'Your bag is empty.',
    emptyLink: '',
    allUrl: '',
    remove: 'Remove',
    decrease: 'Decrease',
    increase: 'Increase',
    size: 'Size',
    from: 'From',
    choose: 'Choose a [options] first.',
    and: 'and',
    sold_out: 'Sold out',
    add_error: 'Could not add to bag.',
    update_error: 'Could not update your bag.',
    added: 'Added to bag.',
    ship_free: 'Free US shipping \u2014 no minimum.'
  };

  function drawerEl() { return $('[data-cz-drawer]'); }

  function cfg() {
    var d = drawerEl();
    var ds = d ? d.dataset : {};
    var strings = {};
    if (ds.strings) { try { strings = JSON.parse(ds.strings); } catch (e) { strings = {}; } }
    var out = {
      cartUrl: ds.cartUrl || '/cart',
      addUrl: ds.cartAddUrl || '/cart/add',
      changeUrl: ds.cartChangeUrl || '/cart/change',
      moneyFormat: ds.moneyFormat || '${{amount}}',
      strings: {}
    };
    Object.keys(DEFAULT_STRINGS).forEach(function (k) { out.strings[k] = strings[k] || DEFAULT_STRINGS[k]; });
    return out;
  }

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    var f = String(format || cfg().moneyFormat).replace(/<[^>]*>/g, '');
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(f);
    var key = m ? m[1] : 'amount';
    var n = Number(cents || 0) / 100;
    function num(precision, thousands, decimal) {
      var parts = n.toFixed(precision).split('.');
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? int + decimal + parts[1] : int;
    }
    var value;
    switch (key) {
      case 'amount_no_decimals': value = num(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = num(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = num(2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = num(0, ' ', '.'); break;
      case 'amount_with_space_separator': value = num(2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = num(2, ' ', '.'); break;
      default: value = num(2, ',', '.');
    }
    return m ? f.replace(m[0], value) : value;
  }

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg) {
    var t = $('[data-cz-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('cz-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('cz-on'); }, 2200);
  }

  /* ---------- saying a list of values ---------- */
  function joinAnd(parts, and) {
    if (parts.length <= 1) return parts.join('');
    if (parts.length === 2) return parts[0] + ' ' + and + ' ' + parts[1];
    return parts.slice(0, -1).join(', ') + ' ' + and + ' ' + parts[parts.length - 1];
  }
  /* A contiguous numeric run collapses to a range ("16\u201320 cm"); returns null when there is
     nothing contiguous to collapse or the values are not all the same kind of number. */
  function numRange(vals) {
    if (vals.length < 3) return null;
    var m = vals.map(function (v) { return String(v).match(/^\s*(\d+(?:\.\d+)?)\s*(mm|cm|in|g)?\b/i); });
    if (!m.every(Boolean)) return null;
    var unit = (m[0][2] || '').toLowerCase();
    if (!m.every(function (x) { return (x[2] || '').toLowerCase() === unit; })) return null;
    var nums = m.map(function (x) { return x[1]; });
    var out = [], i = 0, collapsed = false;
    while (i < nums.length) {
      var j = i;
      while (j + 1 < nums.length && Number(nums[j + 1]) === Number(nums[j]) + 1) j++;
      if (j > i) { out.push(nums[i] + '\u2013' + nums[j]); collapsed = true; } else out.push(nums[i]);
      i = j + 1;
    }
    if (!collapsed) return null;
    return out.map(function (x) { return unit ? x + ' ' + unit : x; });
  }
  /* Keeps a list of surviving values to a sentence: a run collapses to a range, and anything past
     four values becomes "and N more" rather than seven joiners in flag red on a phone. */
  function sayValues(vals, S) {
    var parts = numRange(vals) || vals.slice();
    if (parts.length > 4) return parts.slice(0, 3).join(', ') + ' ' + S.andMore.replace('[count]', parts.length - 3);
    return joinAnd(parts, S.and);
  }

  /* ---------- size helpers ---------- */
  function splitSize(value) {
    var s = String(value == null ? '' : value);
    var i = s.indexOf(' (');
    if (i < 0) return { label: s, sub: '' };
    return { label: s.slice(0, i), sub: s.slice(i + 2).replace(/\)\s*$/, '') };
  }
  function sizeLineLabel(value, S) {
    var p = splitSize(value);
    var us = p.sub ? p.sub.split('· ').pop().trim() : '';
    return S.size + ' ' + p.label + (us ? ' (' + us + ')' : '');
  }
  function lineLabel(item, S) {
    if (item.product_has_only_default_variant) return '';
    var opts = item.options_with_values || [];
    return opts.map(function (o) {
      if (!o || o.value == null || o.value === 'Default Title') return '';
      if (/^size$/i.test(o.name || '')) return sizeLineLabel(o.value, S);
      return o.value;
    }).filter(Boolean).join(' / ');
  }
  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=128&height=128&crop=center';
  }

  /* ---------- cart: fetch ---------- */
  function parseJson(r) { return r.text().then(function (t) { try { return t ? JSON.parse(t) : {}; } catch (e) { return {}; } }); }
  function fetchCart() {
    var C = cfg();
    return fetch(C.cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(C.strings.update_error); return r.json(); });
  }
  function changeLine(key, quantity) {
    var C = cfg();
    return fetch(C.changeUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) {
      return parseJson(r).then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || C.strings.update_error);
        return data;
      });
    });
  }
  function addToCart(body) {
    var C = cfg();
    var opts = { method: 'POST', credentials: 'same-origin' };
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      opts.body = body;
      opts.headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    } else {
      opts.body = JSON.stringify(body);
      opts.headers = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    }
    return fetch(C.addUrl + '.js', opts).then(function (r) {
      return parseJson(r).then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || C.strings.add_error);
        return data;
      });
    });
  }

  /* ---------- cart: render ---------- */
  function lineHtml(item, S) {
    var label = lineLabel(item, S);
    return '<div class="cz-li" data-cz-line="' + esc(item.key) + '">' +
      (item.image ? '<img src="' + esc(thumb(item.image)) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="cz-li-noimg" aria-hidden="true"></span>') +
      '<div>' +
        '<div class="cz-t">' + esc(item.product_title) + '</div>' +
        (label ? '<div class="cz-v">' + esc(label) + '</div>' : '') +
        '<div class="cz-q">' +
          '<button type="button" data-cz-qty-change="-1" aria-label="' + esc(S.decrease) + '">&minus;</button>' +
          '<span class="cz-num" data-cz-line-qty>' + item.quantity + '</span>' +
          '<button type="button" data-cz-qty-change="1" aria-label="' + esc(S.increase) + '">+</button>' +
          '<span class="cz-num cz-lp" data-cz-line-price>' + esc(formatMoney(item.final_line_price)) + '</span>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="cz-x" data-cz-remove>' + esc(S.remove) + '</button>' +
    '</div>';
  }
  function renderCart(cart) {
    if (!cart || !cart.items) return;
    var C = cfg();
    var S = C.strings;
    $$('[data-cz-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    // Keep the badge's unit word in number with the count ("1 item" / "2 items") - walk F3.
    $$('[data-cz-cart-count-word]').forEach(function (el) {
      var w = el.getAttribute(cart.item_count === 1 ? 'data-one' : 'data-other');
      if (w) el.textContent = ' ' + w;
    });
    var d = drawerEl();
    if (!d) return;
    var box = $('[data-cz-items]', d);
    if (box) {
      box.innerHTML = cart.items.length
        ? cart.items.map(function (item) { return lineHtml(item, S); }).join('')
        : '<p class="cz-empty">' + esc(S.empty) + (S.emptyLink && S.allUrl ? ' <a class="cz-linkish" href="' + esc(S.allUrl) + '">' + esc(S.emptyLink) + '</a>' : '') + '</p>';
    }
    var sub = $('[data-cz-subtotal]', d);
    if (sub) sub.textContent = formatMoney(cart.total_price);
    var cb = $('[data-cz-checkout]', d);
    if (cb) { if (cart.item_count > 0) { cb.removeAttribute('disabled'); cb.hidden = false; } else { cb.setAttribute('disabled', ''); cb.hidden = true; } }
  }
  /* The shipping line used to be a progress meter ("add $18 more and shipping is free") that this
     function re-rendered on every cart change. Shipping is now free on every order with no
     threshold, so the line is static: Liquid renders it once and nothing here touches it. */
  function refreshCart() {
    return fetchCart().then(function (cart) { renderCart(cart); return cart; }).catch(function () { return null; });
  }
  function refocusBag() {
    var d = drawerEl();
    if (!d) return;
    var n = $('[data-cz-items] [data-cz-remove]', d) || $('[data-cz-cart-close]', d);
    if (n) n.focus();
  }

  /* ---------- cart: drawer open / close ---------- */
  var lastFocus = null;
  var isOpen = false;
  function inertTargets() {
    return $$('#MainContent, [data-cz-header], [data-cz-footer], .cz-skip');
  }
  function openCart() {
    var d = drawerEl();
    if (!d) { window.location.href = cfg().cartUrl; return; }
    try { toggleMenu(false); } catch (e) {}
    if (!isOpen) lastFocus = doc.activeElement;
    d.classList.add('cz-on');
    d.setAttribute('aria-hidden', 'false');
    var s = $('[data-cz-scrim]');
    if (s) s.classList.add('cz-on');
    inertTargets().forEach(function (el) { el.setAttribute('inert', ''); });
    doc.body.style.overflow = 'hidden';
    $$('[data-cz-cart-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    isOpen = true;
    setTimeout(function () { var c = $('[data-cz-cart-close]', d); if (c) c.focus(); }, 30);
  }
  function closeCart() {
    var d = drawerEl();
    if (!d) return;
    d.classList.remove('cz-on');
    d.setAttribute('aria-hidden', 'true');
    var s = $('[data-cz-scrim]');
    if (s) s.classList.remove('cz-on');
    inertTargets().forEach(function (el) { el.removeAttribute('inert'); });
    doc.body.style.overflow = '';
    $$('[data-cz-cart-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    isOpen = false;
    if (lastFocus && typeof lastFocus.focus === 'function' && doc.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }
  function focusables(root) {
    return $$('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', root).filter(function (x) {
      return !x.disabled && x.offsetParent !== null && x.getAttribute('aria-hidden') !== 'true';
    });
  }

  /* ---------- mobile menu ---------- */
  function menuEl() { return $('#mnav') || $('.cz-mnav'); }
  function toggleMenu(force) {
    var m = menuEl();
    if (!m) return;
    var on = typeof force === 'boolean' ? force : !m.classList.contains('cz-on');
    // The panel's height cap is 100dvh minus the header's bottom edge. CSS cannot measure that
    // (a percentage max-height inside an auto-height header resolves to nothing — the bug that
    // left Contact under the fold, G3 2026-09-15), so measure it here on every open.
    if (on) {
      var hdr = m.closest('.cz-header') || $('.cz-header');
      var bottom = hdr ? hdr.getBoundingClientRect().bottom : 0;
      if (bottom > 0) document.documentElement.style.setProperty('--cz-header-h', Math.round(bottom) + 'px');
    }
    m.classList.toggle('cz-on', on);
    $$('[data-cz-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }

  /* ---------- product quantity stepper ---------- */
  function stepQty(btn) {
    var box = btn.closest('.cz-qty');
    if (!box || box.closest('[data-cz-drawer]') || box.closest('[data-cz-bound]')) return false;
    if (btn.hasAttribute('data-cz-qty-dec') || btn.hasAttribute('data-cz-qty-inc')) return false;
    var delta = null;
    ['data-cz-qty-step', 'data-delta', 'data-step'].forEach(function (a) {
      if (delta == null && btn.hasAttribute(a)) delta = Number(btn.getAttribute(a));
    });
    if (delta == null || isNaN(delta)) {
      var btns = $$('button', box);
      delta = btns.indexOf(btn) === 0 ? -1 : 1;
    }
    var scope = box.closest('form') || box.closest('[data-cz-product]') || box.closest('.cz-buy') || box.parentElement;
    var input = $('input[name="quantity"]', scope) || $('input[name="quantity"]', box) || $('input', box);
    var display = $('[data-cz-qty-value]', box) || $('span', box) || $('output', box);
    var cur = Number((input && input.value) || (display && display.textContent) || 1);
    if (isNaN(cur) || cur < 1) cur = 1;
    var min = Number(input && input.min) || 1;
    var max = Number(input && input.max) || 10;
    cur = Math.max(min, Math.min(max, cur + delta));
    if (input) input.value = cur;
    if (display && display !== input) display.textContent = cur;
    return true;
  }

  /* ---------- gallery thumbs ---------- */
  function swapThumb(btn) {
    var thumbs = btn.closest('.cz-thumbs');
    if (!thumbs || thumbs.closest('[data-cz-bound]')) return false;
    var gal = thumbs.closest('.cz-gal') || thumbs.parentElement;
    var main = $('.cz-main img', gal) || $('[data-cz-gal-main] img', gal) || $('img', gal);
    var inner = $('img', btn);
    var src = btn.getAttribute('data-cz-src') || btn.getAttribute('data-src') || (inner && (inner.getAttribute('data-cz-full') || inner.getAttribute('data-full') || inner.currentSrc || inner.src));
    if (main && src && main !== inner) {
      main.src = src;
      var srcset = btn.getAttribute('data-cz-srcset') || btn.getAttribute('data-srcset');
      if (srcset) main.setAttribute('srcset', srcset);
      else if (main.hasAttribute('srcset')) main.removeAttribute('srcset');
      var alt = btn.getAttribute('data-cz-alt') || btn.getAttribute('data-alt');
      if (alt != null) main.alt = alt;
    }
    $$('button', thumbs).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    return true;
  }

  /* ---------- variant picker ---------- */
  var pickers = [];
  function pickerFor(el) {
    pickers = pickers.filter(function (p) { return doc.contains(p.root); });
    for (var i = 0; i < pickers.length; i++) if (pickers[i].root.contains(el)) return pickers[i];
    return null;
  }
  function firstAttr(el, names) {
    for (var i = 0; i < names.length; i++) {
      if (el.hasAttribute(names[i])) return el.getAttribute(names[i]);
    }
    return null;
  }
  function normalizeOptions(o) {
    if (!Array.isArray(o)) return null;
    var names = o.map(function (x) {
      if (typeof x === 'string') return x;
      return (x && (x.name || x.label || x.title)) || '';
    }).filter(Boolean);
    return names.length ? names : null;
  }
  function looksLikeVariants(v) {
    return Array.isArray(v) && v.length > 0 && v[0] && typeof v[0] === 'object' && 'id' in v[0] && ('option1' in v[0] || Array.isArray(v[0].options));
  }
  function looksLikeOptions(v) {
    return Array.isArray(v) && v.length > 0 && (typeof v[0] === 'string' || (v[0] && typeof v[0] === 'object' && 'name' in v[0] && ('values' in v[0] || 'position' in v[0])));
  }
  function readData(root) {
    var variants = null;
    var optionNames = null;
    var meta = null;
    $$('script[type="application/json"]', root).forEach(function (s) {
      var v;
      try { v = JSON.parse(s.textContent); } catch (e) { return; }
      if (s.hasAttribute('data-cz-variants') || s.hasAttribute('data-variants') || looksLikeVariants(v)) {
        if (Array.isArray(v)) { variants = v; return; }
      }
      if (s.hasAttribute('data-cz-options') || s.hasAttribute('data-options') || looksLikeOptions(v)) {
        if (Array.isArray(v)) { optionNames = normalizeOptions(v); return; }
      }
      if (v && typeof v === 'object' && Array.isArray(v.variants)) {
        variants = v.variants;
        meta = v;
        if (v.options && !optionNames) optionNames = normalizeOptions(v.options);
      }
    });
    if (variants && !optionNames) {
      var n = 0;
      variants.forEach(function (v) {
        var c = Array.isArray(v.options) ? v.options.length : ['option1', 'option2', 'option3'].filter(function (k) { return v[k] != null; }).length;
        if (c > n) n = c;
      });
      optionNames = [];
      for (var i = 0; i < n; i++) optionNames.push('Option ' + (i + 1));
    }
    return { variants: variants, optionNames: optionNames, meta: meta };
  }
  function valsOf(v) {
    if (Array.isArray(v.options)) return v.options.map(function (x) { return x == null ? null : String(x); });
    return [v.option1, v.option2, v.option3].map(function (x) { return x == null ? null : String(x); });
  }
  function nameIndex(nm, names) {
    if (nm == null) return -1;
    var s = String(nm).trim();
    for (var i = 0; i < names.length; i++) if (names[i].toLowerCase() === s.toLowerCase()) return i;
    if (/^\d+$/.test(s)) { var n = Number(s); if (n >= 0 && n < names.length) return n; }
    return -1;
  }
  function optionIndexFor(el, names) {
    var idx = firstAttr(el, ['data-cz-option-index', 'data-option-index', 'data-index']);
    if (idx != null && idx !== '' && !isNaN(Number(idx))) return Number(idx);
    var pos = firstAttr(el, ['data-cz-option-position', 'data-option-position', 'data-position']);
    if (pos != null && pos !== '' && !isNaN(Number(pos))) return Number(pos) - 1;
    var nm = firstAttr(el, ['data-cz-option', 'data-cz-option-name', 'data-option-name', 'data-option']);
    if (nm != null) { var r = nameIndex(nm, names); if (r > -1) return r; }
    if (el.tagName === 'INPUT' && el.name) { var r2 = nameIndex(el.name.replace(/^options\[|\]$/g, ''), names); if (r2 > -1) return r2; }
    var grp = el.closest('[data-cz-option], [data-cz-option-name], [data-cz-option-index], [data-option-name], [data-option-index], [data-option], [role="group"], fieldset, .cz-optbox');
    while (grp) {
      var gi = firstAttr(grp, ['data-cz-option-index', 'data-option-index']);
      if (gi != null && gi !== '' && !isNaN(Number(gi))) return Number(gi);
      var gp = firstAttr(grp, ['data-cz-option-position', 'data-option-position']);
      if (gp != null && gp !== '' && !isNaN(Number(gp))) return Number(gp) - 1;
      var gn = firstAttr(grp, ['data-cz-option', 'data-cz-option-name', 'data-option-name', 'data-option', 'aria-label']);
      if (gn != null) { var rg = nameIndex(gn, names); if (rg > -1) return rg; }
      var lg = $('legend, .cz-lab', grp);
      if (lg) { var rl = nameIndex((lg.textContent || '').split(':')[0], names); if (rl > -1) return rl; }
      grp = grp.parentElement ? grp.parentElement.closest('[data-cz-option], [data-option-name], [role="group"], fieldset, .cz-optbox') : null;
    }
    return -1;
  }
  function rawValueOf(el) {
    var input = el.tagName === 'INPUT' ? el : $('input[type="radio"], input[type="checkbox"]', el);
    var v = firstAttr(el, ['data-cz-value', 'data-value', 'data-option-value', 'value']);
    if (v == null && input) v = input.value;
    if (v == null) {
      var txt = '';
      Array.prototype.forEach.call(el.childNodes, function (n) { if (n.nodeType === 3) txt += n.textContent; });
      v = txt.trim() || (el.textContent || '').trim();
    }
    return v == null ? '' : String(v);
  }

  function initPicker(root) {
    if (!root || root.__czPicker) return root ? root.__czPicker : null;
    var data = readData(root);
    var variants = data.variants;
    var names = data.optionNames;
    if (!variants || !names) return null;
    var base = cfg().strings;
    var rd = root.dataset || {};
    var S = {
      size: base.size,
      sizeTpl: rd.sizePrefix && rd.sizePrefix.indexOf('%s') > -1 ? rd.sizePrefix : base.size + ' %s',
      from: base.from,
      choose: rd.msgChoose ? rd.msgChoose.replace('%s', '[options]') : base.choose,
      and: base.and,
      sold_out: rd.msgSoldOut || base.sold_out,
      add: rd.msgAdd || '',
      cleared: rd.msgCleared || 'We cleared your [dims] \u2014 [picked] only comes in [values].',
      clearedNone: rd.msgClearedNone || 'We cleared your [dims] \u2014 nothing else is stocked with [picked].',
      onlyOne: rd.msgOnlyOne || '[picked] comes in [values].',
      onlyMany: rd.msgOnlyMany || '[picked] come in [values].',
      andMore: rd.msgAndMore || 'and [count] more',
      offHint: rd.msgOffHint || 'Dashed options aren\u2019t stocked with the rest of your choices \u2014 pick one and we\u2019ll clear what conflicts.'
    };
    var meta = data.meta || {};
    var sel = names.map(function () { return null; });
    var distinct = names.map(function (_, i) {
      var seen = [];
      variants.forEach(function (v) { var x = valsOf(v)[i]; if (x != null && seen.indexOf(x) < 0) seen.push(x); });
      return seen;
    });
    var idInput = $('input[name="id"]', root);
    var priceEl = $('[data-cz-price]', root) || $('.cz-price', root);
    var fromEl = priceEl ? $('.cz-from', priceEl) : null;
    if (fromEl && fromEl.textContent.trim()) S.from = fromEl.textContent.trim();
    var msgEl = $('[data-cz-optmsg]', root) || $('.cz-optmsg', root);
    var whyEl = $('[data-cz-optwhy]', root) || $('.cz-optwhy', root);
    var addForm = $('form[action*="/cart/add"]', root);
    var addBtn = addForm ? ($('[data-cz-add]', addForm) || $('button[type="submit"], input[type="submit"]', addForm)) : ($('[data-cz-add]', root) || null);
    var baseImg = null;   // filled just before the first render() - see the snapshot note below
    /* Only a product that swaps photos per variant may reset the gallery: on all-static products
       a selection must never touch the image (it would clobber a thumbnail the shopper picked). */
    var hasVariantPhotos = variants.some(function (v) { return !!v.image; });
    var opts = [];

    $$('.cz-opt, input[type="radio"][name^="options["]', root).forEach(function (el) {
      var isInput = el.tagName === 'INPUT';
      var host = isInput ? (el.closest('.cz-opt') || el.closest('label') || el) : el;
      if (isInput && opts.some(function (o) { return o.input === el; })) return;
      if (!isInput && $('input[type="radio"]', el) && opts.some(function (o) { return o.el === el; })) return;
      var input = isInput ? el : $('input[type="radio"]', el);
      var idx = optionIndexFor(isInput ? el : host, names);
      if (idx < 0 && input) idx = optionIndexFor(input, names);
      if (idx < 0 || idx >= names.length) return;
      var raw = rawValueOf(isInput ? el : host);
      var value = resolve(idx, raw);
      if (value == null) return;
      opts.push({ el: host, input: input || null, idx: idx, value: value });
    });

    function resolve(idx, raw) {
      var list = distinct[idx];
      if (list.indexOf(raw) > -1) return raw;
      var stripped = raw.replace(new RegExp('^' + S.size.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s+', 'i'), '').replace(/^Size\s+/i, '').trim();
      for (var i = 0; i < list.length; i++) {
        var p = splitSize(list[i]);
        if (p.label === raw || p.label === stripped || list[i] === stripped) return list[i];
      }
      return null;
    }
    function groupIdx(i) { return opts.filter(function (o) { return o.idx === i; }); }
    function isOn(o) { return o.input ? !!o.input.checked : o.el.getAttribute('aria-pressed') === 'true'; }
    function setOn(o, on) {
      if (o.input) o.input.checked = !!on;
      o.el.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    /* `any` = the value exists on some variant at all; `ok` = it is stocked alongside the rest of
       the current selection. ONLY a value with no variant at all is disabled: a disabled button
       cannot fire a pick, so its cascade-clear could never run and the value would be unreachable
       without a reload. Everything else stays clickable and is marked [data-off] (gate D7 UX M7). */
    function setState(o, any, ok) {
      var dis = !any;
      if (o.input) o.input.disabled = dis;
      if (o.el.tagName === 'BUTTON') { if (dis) o.el.setAttribute('disabled', ''); else o.el.removeAttribute('disabled'); }
      o.el.setAttribute('aria-disabled', dis ? 'true' : 'false');
      o.el.classList.toggle('cz-unavailable', dis);
      if (any && !ok) o.el.setAttribute('data-off', '1'); else o.el.removeAttribute('data-off');
    }
    function existsAny(i, value) {
      return variants.some(function (v) { return valsOf(v)[i] === value; });
    }
    function exists(i, value) {
      return variants.some(function (v) {
        var vv = valsOf(v);
        if (vv[i] !== value) return false;
        for (var j = 0; j < names.length; j++) if (j !== i && sel[j] != null && vv[j] !== sel[j]) return false;
        return true;
      });
    }
    function complete() { return sel.every(function (x) { return x != null; }); }
    function matched() {
      if (!complete()) return null;
      for (var k = 0; k < variants.length; k++) {
        var vv = valsOf(variants[k]);
        var ok = true;
        for (var j = 0; j < names.length; j++) if (vv[j] !== sel[j]) { ok = false; break; }
        if (ok) return variants[k];
      }
      return null;
    }
    function isAvailable(v) { return v && v.available !== false; }
    function sizeText(label) { return S.sizeTpl.replace('%s', label); }
    function displayLabel(i, value) {
      return /^size$/i.test(names[i]) ? sizeText(splitSize(value).label) : value;
    }
    function setMsg(text) { if (msgEl) msgEl.textContent = text || ''; }
    function priceText(v) { return v.price_formatted ? String(v.price_formatted).replace(/<[^>]*>/g, "") : formatMoney(v.price); }
    function renderPrice() {
      if (!priceEl) return;
      var v = matched();
      if (v) { priceEl.innerHTML = esc(priceText(v)); return; }
      var prices = variants.map(function (x) { return Number(x.price); }).filter(function (p) { return !isNaN(p); });
      if (!prices.length) return;
      var min = Math.min.apply(null, prices);
      var varies = prices.some(function (p) { return p !== min; });
      var minVariant = variants.filter(function (x) { return Number(x.price) === min; })[0];
      var minText = meta.price_min_formatted || (minVariant ? priceText(minVariant) : formatMoney(min));
      priceEl.innerHTML = (varies ? '<small class="cz-from">' + esc(S.from) + ' </small>' : '') + esc(minText);
    }
    /* Names what the current selection IS stocked with, so a dimmed value is never unexplained
       ("SIS comes in US 7 and US 8.") — gate D7 UX M7. */
    function renderWhy(anyOff) {
      if (!whyEl) return;
      var lines = [];
      names.forEach(function (n, i) {
        var g = groupIdx(i);
        if (!g.length) return;
        var avail = [], off = 0;
        g.forEach(function (o) {
          if (exists(i, o.value)) avail.push(o.value);
          else if (existsAny(i, o.value)) off++;
        });
        if (!off || !avail.length) return;
        var ctx = [];
        for (var j = 0; j < names.length; j++) if (j !== i && sel[j] != null) ctx.push(displayLabel(j, sel[j]));
        if (!ctx.length) return;
        var tpl = ctx.length === 1 ? S.onlyOne : S.onlyMany;
        lines.push(tpl.replace('[picked]', joinAnd(ctx, S.and))
                      .replace('[values]', sayValues(avail.map(function (v) { return displayLabel(i, v); }), S)));
      });
      if (!lines.length && anyOff) lines.push(S.offHint);
      whyEl.textContent = lines.join(' ');
      whyEl.hidden = lines.length === 0;
    }
    function render() {
      var anyOff = false;
      opts.forEach(function (o) {
        var any = existsAny(o.idx, o.value);
        var ok = exists(o.idx, o.value);
        if (any && !ok) anyOff = true;
        setOn(o, sel[o.idx] === o.value);
        setState(o, any, ok);
      });
      renderWhy(anyOff);
      names.forEach(function (_, i) {
        var any = groupIdx(i)[0];
        if (!any) return;
        var box = any.el.closest('.cz-optbox') || any.el.closest('[data-cz-option]') || any.el.closest('fieldset') || any.el.parentElement;
        var chosen = box ? $('[data-cz-chosen]', box) : null;
        if (chosen) chosen.innerHTML = sel[i] != null ? ': <b class="cz-chosen">' + esc(displayLabel(i, sel[i])) + '</b>' : '';
      });
      var v = matched();
      if (idInput) idInput.value = v ? v.id : '';
      var imgV = v;
      if (!imgV) {   // partial pick: first variant agreeing with every chosen option that has its own photo
        for (var q = 0; q < variants.length; q++) {
          var vq = valsOf(variants[q]), okq = true, anySel = false;
          for (var jj = 0; jj < names.length; jj++) { if (sel[jj] != null) { anySel = true; if (vq[jj] !== sel[jj]) { okq = false; break; } } }
          if (anySel && okq && variants[q].image) { imgV = variants[q]; break; }
        }
      }
      if (imgV && imgV.image) {   // per-variant photo (M6): swap the main image, keep the product alt
        var galMain = $('.cz-main img', root.closest('.cz-pdp') || doc) || $('[data-cz-gal-main] img', doc);
        if (galMain && galMain.getAttribute('src') !== imgV.image) { galMain.removeAttribute('srcset'); galMain.src = imgV.image; }
        /* Keep the thumbnail strip in step. The swap above changed the main image but not which
           thumb reads as selected, so picking Carbon Black left thumb 1 outlined while thumb 4's
           photo was showing (gate G3, 2026-09-05). Match on the path, ignoring the width query
           the two sides render at. */
        if (galMain) {
          var _base = function (u) { return (u || '').split('?')[0].split('/').pop(); };
          var _want = _base(imgV.image);
          var _thumbs = (root.closest('.cz-pdp') || doc).querySelectorAll('.cz-thumbs [aria-pressed]');
          for (var _t = 0; _t < _thumbs.length; _t++) {
            var _src = _thumbs[_t].getAttribute('data-src') || _base((_thumbs[_t].querySelector('img') || {}).src);
            _thumbs[_t].setAttribute('aria-pressed', _base(_src) === _want ? 'true' : 'false');
          }
        }
      } else if (hasVariantPhotos && baseImg && baseImg.src && sel.some(function (x) { return x != null; })) {
        /* The pick resolves to no photo-bearing variant (a photo-less value on a mixed-photo
           axis, e.g. the A-Z initial ring's 12 unphotographed letters). Without this branch the
           PREVIOUS pick's photo stays up under the new value's name (variant audit 2026-08-25
           H1) - reset the gallery to the product's featured shot and its original alt. */
        var galBase = $('.cz-main img', root.closest('.cz-pdp') || doc) || $('[data-cz-gal-main] img', doc);
        if (galBase && galBase.getAttribute('src') !== baseImg.src) {
          galBase.src = baseImg.src;
          if (baseImg.srcset) galBase.setAttribute('srcset', baseImg.srcset); else galBase.removeAttribute('srcset');
          if (baseImg.alt != null) galBase.alt = baseImg.alt;
        }
      }
      if (v && window.history && history.replaceState) {
        try { var u = new URL(location.href); if (u.searchParams.get('variant') !== String(v.id)) { u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } } catch (e) {}
      }
      if (addBtn) {
        if (v && !isAvailable(v)) {
          addBtn.setAttribute('disabled', '');
          setMsg(S.sold_out);
          if (S.add) addBtn.textContent = S.sold_out;
        } else {
          addBtn.removeAttribute('disabled');
          if (S.add) addBtn.textContent = S.add;
        }
        if (msgEl && msgEl.id && !v) addBtn.setAttribute('aria-describedby', msgEl.id);
        else if (msgEl && msgEl.id) addBtn.removeAttribute('aria-describedby');
      }
      renderPrice();
    }
    /* Does the new pick land on a real variant if these axes are kept? */
    function fitsWith(i, value, keep) {
      return variants.some(function (v) {
        var vv = valsOf(v);
        if (vv[i] !== value) return false;
        for (var k = 0; k < keep.length; k++) { var j = keep[k]; if (vv[j] !== sel[j]) return false; }
        return true;
      });
    }
    /* The FEWEST axes that have to go for the new pick to land on a real variant. The old code
       tested every other axis against a `sel` that still held the axes it was itself about to
       clear, so mutually-entangled constraints all failed together — 18 of 60 switches on the
       five-row band wiped two axes that were still valid (gate D7 UX M2). Axes are few, so an
       exact search over subsets is cheap: smallest set wins, ties go to the axis listed last,
       since the shopper reads top-down and the earlier choice is the one worth keeping. */
    function clearSet(i, value) {
      var others = [];
      for (var j = 0; j < names.length; j++) if (j !== i && sel[j] != null) others.push(j);
      if (fitsWith(i, value, others)) return [];
      var subs = [];
      for (var m = 1; m < (1 << others.length); m++) {
        var one = [];
        for (var b = 0; b < others.length; b++) if ((m >> b) & 1) one.push(others[b]);
        subs.push(one);
      }
      function rank(a) { return a.reduce(function (x, y) { return x + y; }, 0); }
      subs.sort(function (a, b) { return a.length - b.length || rank(b) - rank(a); });
      for (var q = 0; q < subs.length; q++) {
        var drop = subs[q];
        var keep = others.filter(function (j) { return drop.indexOf(j) < 0; });
        if (fitsWith(i, value, keep)) return drop;
      }
      return others;
    }
    function pick(i, value) {
      sel[i] = value;
      var cleared = clearSet(i, value);
      cleared.forEach(function (j) { sel[j] = null; });
      if (cleared.length) {
        var dims = joinAnd(cleared.map(function (j) { return names[j].toLowerCase(); }), S.and);
        var picked = displayLabel(i, value);
        var says = [];
        cleared.forEach(function (j) {
          var left = distinct[j].filter(function (v) { return exists(j, v); }).map(function (v) { return displayLabel(j, v); });
          if (left.length) says.push(sayValues(left, S));
        });
        if (says.length) setMsg(S.cleared.replace('[dims]', dims).replace('[picked]', picked).replace('[values]', joinAnd(says, S.and)));
        else setMsg(S.clearedNone.replace('[dims]', dims).replace('[picked]', picked));
      } else {
        setMsg('');
      }
      render();
    }
    function ensureComplete() {
      var v = matched();
      if (v) {
        if (!isAvailable(v)) { setMsg(S.sold_out); return false; }
        setMsg('');
        return true;
      }
      var missing = [];
      var firstGroup = null;
      names.forEach(function (n, i) {
        if (sel[i] == null) { missing.push(n.toLowerCase()); if (!firstGroup) firstGroup = groupIdx(i); }
      });
      setMsg(S.choose.replace('[options]', missing.reduce(function(a,x,i,arr){return i===0?x:(i===arr.length-1?a+' '+S.and+' '+x:a+', '+x);},'')));
      var target = null;
      if (firstGroup && firstGroup.length) {
        target = firstGroup.filter(function (o) { return o.el.getAttribute('aria-disabled') !== 'true'; })[0] || firstGroup[0];
      }
      if (target) { (target.input || target.el).focus(); }
      else if (msgEl && msgEl.focus) { msgEl.setAttribute('tabindex', '-1'); msgEl.focus(); }
      return false;
    }

    opts.forEach(function (o) {
      if (/^size$/i.test(names[o.idx]) && !$('small', o.el)) {
        var p = splitSize(o.value);
        if (p.sub) {
          var inp = o.input && o.el.contains(o.input) ? o.input : null;
          o.el.innerHTML = esc(sizeText(p.label)) + '<small>' + esc(p.sub) + '</small>';
          if (inp) o.el.insertBefore(inp, o.el.firstChild);
        }
      }
      if (o.el.tagName === 'BUTTON' && !o.el.getAttribute('type')) o.el.setAttribute('type', 'button');
    });

    opts.forEach(function (o) { if (isOn(o)) sel[o.idx] = o.value; });
    names.forEach(function (_, i) { if (sel[i] == null && distinct[i].length === 1) sel[i] = distinct[i][0]; });
    names.forEach(function (_, i) {
      if (sel[i] == null && distinct[i].length > 1 && !groupIdx(i).length) {
        var selEl = $$('select', root).filter(function (s) { return optionIndexFor(s, names) === i; })[0];
        if (selEl && distinct[i].indexOf(selEl.value) > -1) sel[i] = selEl.value;
      }
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.cz-opt');
      if (!btn || !root.contains(btn)) return;
      var o = opts.filter(function (x) { return x.el === btn; })[0];
      if (!o || o.input) return;
      if (btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      e.preventDefault();
      pick(o.idx, o.value);
    });
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.tagName === 'INPUT' && t.type === 'radio') {
        var o = opts.filter(function (x) { return x.input === t; })[0];
        if (o && t.checked) pick(o.idx, o.value);
        return;
      }
      if (t.tagName === 'SELECT') {
        var i = optionIndexFor(t, names);
        if (i > -1 && distinct[i].indexOf(t.value) > -1) pick(i, t.value);
      }
    });

    var picker = {
      root: root,
      names: names,
      variants: variants,
      get selection() { return sel.slice(); },
      matched: matched,
      isComplete: complete,
      ensureComplete: ensureComplete,
      pick: pick,
      render: render
    };
    root.__czPicker = picker;
    pickers.push(picker);
    /* Featured-image snapshot for the no-photo-variant reset (audit 2026-08-25 H1). Taken
       BEFORE the first render() so it always holds the Liquid-rendered featured shot, never a
       variant swap. */
    var baseEl = $('.cz-main img', root.closest('.cz-pdp') || doc) || $('[data-cz-gal-main] img', doc);
    baseImg = baseEl ? { src: baseEl.getAttribute('src'), srcset: baseEl.getAttribute('srcset'), alt: baseEl.getAttribute('alt') } : null;
    render();
    return picker;
  }

  function autoInitPickers() {
    var roots = $$('[data-cz-product], [data-cz-variant-picker], [data-variant-picker]');
    $$('form[action*="/cart/add"]').forEach(function (f) {
      var r = f.closest('[data-cz-product]') || f.closest('.cz-pdp') || f.closest('.shopify-section') || f.closest('section') || f.parentElement;
      if (r && roots.indexOf(r) < 0) roots.push(r);
    });
    roots.forEach(function (r) { if (!r.__czPicker) initPicker(r); });
  }

  /* ---------- delegated events ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var el;

    if ((el = t.closest('[data-cz-cart-open]'))) {
      e.preventDefault();
      openCart();
      refreshCart();
      return;
    }
    if (t.closest('[data-cz-cart-close]') || t.closest('[data-cz-scrim]')) {
      e.preventDefault();
      closeCart();
      return;
    }
    if ((el = t.closest('[data-cz-menu-toggle]'))) {
      e.preventDefault();
      toggleMenu();
      return;
    }
    if ((el = t.closest('[data-cz-qty-change]'))) {
      var li = el.closest('[data-cz-line]');
      if (!li) return;
      e.preventDefault();
      if (li.getAttribute('aria-busy') === 'true') return;   // one request in flight per line
      var qEl = $('[data-cz-line-qty]', li);
      var cur = Number(qEl ? qEl.textContent : 1) || 1;
      var next = cur + Number(el.getAttribute('data-cz-qty-change'));
      if (next < 0) next = 0;
      if (next > 10) next = 10;
      var key = li.getAttribute('data-cz-line');
      li.setAttribute('aria-busy', 'true');
      changeLine(key, next).then(function (cart) {
        renderCart(cart);
        if (next === 0) refocusBag();
        else {
          var again = $('[data-cz-line="' + key.replace(/"/g, '\\"') + '"] [data-cz-qty-change="' + el.getAttribute('data-cz-qty-change') + '"]');
          if (again) again.focus();
        }
      }).catch(function (err) { li.removeAttribute('aria-busy'); toast(err.message || cfg().strings.update_error); });
      return;
    }
    if ((el = t.closest('[data-cz-remove]'))) {
      var line = el.closest('[data-cz-line]');
      if (!line) return;
      e.preventDefault();
      line.setAttribute('aria-busy', 'true');
      changeLine(line.getAttribute('data-cz-line'), 0).then(function (cart) {
        renderCart(cart);
        refocusBag();
      }).catch(function (err) { line.removeAttribute('aria-busy'); toast(err.message || cfg().strings.update_error); });
      return;
    }
    if ((el = t.closest('.cz-qty button'))) {
      if (stepQty(el)) { e.preventDefault(); return; }
    }
    if ((el = t.closest('.cz-thumbs button'))) {
      if (swapThumb(el)) { e.preventDefault(); return; }
    }
  });

  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add/.test(action)) return;
    e.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;
    var picker = pickerFor(form);
    if (picker && !picker.ensureComplete()) return;
    var fd = new FormData(form);
    if (!fd.get('id')) { if (picker) picker.ensureComplete(); return; }
    var btn = $('button[type="submit"], input[type="submit"]', form);
    form.setAttribute('aria-busy', 'true');
    if (btn) btn.setAttribute('aria-busy', 'true');
    addToCart(fd).then(function () { return fetchCart(); }).then(function (cart) {
      renderCart(cart);
      openCart();
    }).catch(function (err) {
      toast(err && err.message ? err.message : cfg().strings.add_error);
    }).then(function () {
      form.removeAttribute('aria-busy');
      if (btn) btn.removeAttribute('aria-busy');
    });
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (isOpen) { e.preventDefault(); closeCart(); return; }
      var m = menuEl();
      if (m && m.classList.contains('cz-on')) { e.preventDefault(); toggleMenu(false); var b = $('[data-cz-menu-toggle]'); if (b) b.focus(); }
      return;
    }
    if (e.key !== 'Tab' || !isOpen) return;
    var d = drawerEl();
    if (!d) return;
    var f = focusables(d);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0];
    var last = f[f.length - 1];
    var active = doc.activeElement;
    if (!d.contains(active)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  });

  doc.addEventListener('focusin', function (e) {
    if (!isOpen) return;
    var d = drawerEl();
    if (d && !d.contains(e.target)) {
      var f = focusables(d);
      if (f.length) f[0].focus();
    }
  });

  doc.addEventListener('shopify:section:load', function () { autoInitPickers(); });
  doc.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-cz-drawer]')) openCart();
  });
  doc.addEventListener('shopify:section:deselect', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-cz-drawer]')) closeCart();
  });

  window.addEventListener('pageshow', function () { refreshCart(); });

  function boot() {
    autoInitPickers();
  }

  window.czCart = {
    open: openCart,
    close: closeCart,
    refresh: refreshCart,
    add: function (body) {
      return addToCart(body).then(function () { return fetchCart(); }).then(function (cart) { renderCart(cart); openCart(); return cart; });
    },
    change: function (key, qty) { return changeLine(key, qty).then(function (cart) { renderCart(cart); return cart; }); },
    render: renderCart,
    formatMoney: formatMoney,
    get isOpen() { return isOpen; }
  };
  window.czToast = toast;
  window.czVariantPicker = {
    init: initPicker,
    get: function (el) { return el && el.__czPicker ? el.__czPicker : pickerFor(el); }
  };

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();


  /* Predictive search: Shopify's /search/suggest.json, products only.
     Progressive enhancement — the form still submits normally without JS. */
  (function () {
    var input = document.querySelector('[data-cz-suggest]');
    var box = document.getElementById('cz-sugg');
    if (!input || !box) return;
    var timer = null, controller = null, items = [], cursor = -1;
    function close() { if (controller) { try { controller.abort(); } catch (e) {} controller = null; } box.hidden = true; box.innerHTML = ''; items = []; cursor = -1; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); }
    /* suggest.json returns price as a decimal string ("50.99"), not cents like cart.js */
    function money(v) {
      var n = parseFloat(v);
      if (!isFinite(n)) return '';
      try { return formatMoney(Math.round(n * 100)); } catch (e) { return ''; }
    }
    function render(products, term) {
      if (!products.length) { box.innerHTML = '<p class="cz-sugg-none" role="presentation">' + esc(term) + ' \u2014 no matches</p>'; }
      else {
        box.innerHTML = products.map(function (p) {
          var src = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
          if (src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=88';
          var img = src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="44" height="44">' : '<span class="cz-sugg-ph" aria-hidden="true"></span>';
          return '<a role="option" href="' + esc(p.url) + '">' + img +
            '<span><span class="cz-sugg-t">' + esc(p.title) + '</span><br><span class="cz-sugg-p">' + money(p.price) + '</span></span></a>';
        }).join('');
      }
      items = [].slice.call(box.querySelectorAll('a'));
      items.forEach(function (a, i) { a.id = 'cz-sugg-' + i; });
      cursor = -1; box.hidden = false; input.setAttribute('aria-expanded', 'true');
    }
    function fetchSuggest(term) {
      if (controller) controller.abort();
      controller = typeof AbortController === 'function' ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=5';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = ((d.resources || {}).results || {}).products || [];
          if (document.activeElement === input && input.value.trim() === term) render(ps, term);
        })
        .catch(function () { /* aborted or offline: leave the plain form to do its job */ });
    }
    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < 2) { close(); return; }
      timer = setTimeout(function () { fetchSuggest(term); }, 180);
    });
    input.addEventListener('keydown', function (e) {
      if (box.hidden || !items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (cursor > -1) items[cursor].removeAttribute('aria-selected');
        cursor = e.key === 'ArrowDown' ? (cursor + 1) % items.length : (cursor <= 0 ? items.length - 1 : cursor - 1);
        items[cursor].setAttribute('aria-selected', 'true'); items[cursor].scrollIntoView({ block: 'nearest' });
        input.setAttribute('aria-activedescendant', items[cursor].id);
      } else if (e.key === 'Enter' && cursor > -1) { e.preventDefault(); items[cursor].click(); }
      else if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target) && e.target !== input) close(); });
    box.addEventListener('mousedown', function (e) { e.preventDefault(); });   // keep focus so a slow click still lands
    input.addEventListener('blur', function () { setTimeout(close, 150); });
  })();
})();
